<template>
  <Select
    class="two-line-select"
    :popper-class="popperClass"
    :value-key="valueKey"
    :value="value"
    @visible-change="onVisible"
    ref="sel"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />

    <template
      v-if="value !== null && value !== undefined"
      slot="prefix"
    >
      <div
        class="two-line-select__selected"
        @click.stop="toggle"
      >
        <slot
          name="selected"
          :value="value"
        >
          <template v-if="selectedOption">
            <div class="two-line-select__value">
              {{ selectedOption[valueField] || '' }}
            </div>
            <div
              class="two-line-select__description"
              :class="{ 'two-line-select__long-description': !selectedOption[valueField] }"
            >
              {{ selectedOption[descriptionField] || '' }}
            </div>
          </template>
        </slot>
      </div>
    </template>
  </Select>
</template>

<script>
import Select from './Select.vue';

export default {
  name: 'TwoLineSelect',
  components: {
    Select,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [Object, String, Number, Array],
      default: null,
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    popperClass: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    valueField: {
      type: String,
      default: 'value',
    },
    descriptionField: {
      type: String,
      default: 'description',
    },
  },
  computed: {
    selectedOption() {
      if (!this.options || this.value === null || this.value === undefined) {
        return null;
      }

      if (typeof this.value === 'number') {
        return this.options[this.value];
      }

      return this.options.find(opt => opt[this.valueKey] === this.value);
    },
  },
  methods: {
    toggle() {
      this.$refs.sel && this.$refs.sel.toggleMenu();
    },
    onVisible(v) { this.$emit('visible-change', v); },
  },
};
</script>

<style lang="scss" scoped>
.two-line-select {
  :deep() {
    .el-input__inner {
      color: transparent;
      caret-color: transparent;
      padding-top: 35px;
      padding-bottom: 35px;
    }

    .el-input__prefix {
      width: calc(100% - 36px);
      left: 12px;
      color: $--color-text-regular;
    }
  }
}

.two-line-select__selected {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  padding: 8px 0;
  pointer-events: none;
}

.two-line-select__value {
  font-size: rem(16px);
  font-weight: 600;
  line-height: 150%;
}

.two-line-select__description {
  font-size: rem(12px);
  line-height: 16px;
  text-align: left;
  max-height: 32px;
  color: $--color-text-blue;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.two-line-select__long-description {
  -webkit-line-clamp: 3;
  max-height: 48px;
}
</style>
